<template>
  <div class="popup" :class="[`popup-${type}`, { categories_hidden: !categories_visible }]" :data-name="popup">
    <slot name="outer">
      <div class="top-bar">
        <BamLink v-if="type === 'full'" :to="ROUTE.home">
          <img src="/img/logo.svg" width="201" height="31" class="logo" alt="BitSkins">
        </BamLink>
        <slot name="top" />
        <slot v-if="close" name="close">
          <button class="btn-close" @click="handleClose($router)">
            <img src="@/asset/icon/x.svg" class="img-x" alt="">
          </button>
        </slot>
      </div>
      <div class="el">
        <div class="body">
          <slot />
          <div class="models">
<!--            <img v-if="icons && type === 'full'" src="@/asset/img/model-t.png" class="model model-t" alt="">-->
<!--            <img v-if="icons && type === 'full'" src="@/asset/img/model-ct.png" class="model model-ct" alt="">-->
            <img v-if="icons && type === 'basic'" src="@/asset/img/model-street-worker.png" class="model model-sw" alt="">
            <img v-if="icons && type === 'account-restricted banned'" src="@/asset/img/model-skeleton.png" class="model model-skeleton" alt="">
          </div>
        </div>
        <slot name="afterBody" />
        <img v-if="icons && type === 'basic'" src="@/asset/img/bullet.png" class="model model-bullet model-pf mb-left" alt="">
      </div>
      <div class="bottom">
        <slot name="bottom" />
      </div>
    </slot>
  </div>
</template>

<script setup>
import { categories_visible } from '@/hook/header.js';
import { closePopup } from '@/hook/system/popup.js';
import { ROUTE } from '@/facade/router.js';

const props = defineProps({
  popup: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: 'basic',
  },
  icons: {
    type: Boolean,
    default: true,
  },
  close: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['close']);
const handleClose = ($router) => {
  if (props.popup) {
    closePopup($router, props.popup);
  }
  emit('close');
};
</script>
